module.exports = __webpack_public_path__ + "img/threshold-img.bb2f3673.png";